import React, {useState} from 'react';
import * as CSS from 'csstype';
import styled, {css} from 'styled-components';
import {media} from 'library/styled-bs-grid';

interface IProps {
    style?: CSS.Properties;
    className?: string;
    onChangeIndex: Function;
    activeCode: number;
    item?: Array<{
        name: string;
        code: number;
    }>;
}

/**
 * Tabs
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const Tabs: React.FC<IProps> = ({
    style,
    className,
    activeCode,
    item = [],
    onChangeIndex,
}) => {
    const [bottomLineWidth, setBottomLineWidth] = useState(0);
    const [itemPosition, setItemPosition] = useState(0);
    const [isFakeBottomLine, setIsFakeBottomLine] = useState(true);

    const handleChangeEvent = (e: any, itemId: string | number) => {
        // item的中間寬度
        const itemMiddleWidth = e.target.offsetWidth / 2;
        // 螢幕寬度
        const screenWidth = document.body.clientWidth;

        // 切換Tabs類別
        onChangeIndex(itemId);

        // 移動距離算式
        e.target.closest('section').scrollLeft = (e.target.offsetLeft + itemMiddleWidth) - screenWidth / 2;

        // 底線相關

        // 取目標item 寬度
        setBottomLineWidth(e.target.offsetWidth);
        // 取目標item position
        setItemPosition(e.target.offsetLeft);
        setIsFakeBottomLine(false);
    };

    return (
        <TabScrollRoot style={style} className={className}>
            <ItemGroup
                bottomLineWidth={bottomLineWidth}
                itemPosition={itemPosition}
            >
                {
                    item.map(row => (
                        <ItemList key={row.code}>
                            <Item
                                onClick={(e: any) => handleChangeEvent(e, row.code)}
                                active={String(activeCode) === String(row.code)}
                                isFakeBottomLine={isFakeBottomLine && (activeCode.toString() === row.code.toString())}
                            >
                                {row.name}
                            </Item>
                        </ItemList>
                    ))
                }
            </ItemGroup>
        </TabScrollRoot>
    );
};

export default Tabs;

const Item = styled.div<any>`
    font-size: 12px;
    padding: 10px 0;
    cursor: pointer;
    color: #adadad;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
    position: relative;

    ${media.md`
        font-size: 20px;
    `}

    ${media.xl`
        font-size: 26px;
    `}

    ${props => props.isFakeBottomLine && css`
        &:after {
            height: 4px;
            background-color: ${props.theme.primaryColor};
            content: '';
            display: block;
            width: 100%;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
        }
    `}

    ${props => props.active && css`
        color: ${props.theme.primaryColor};
        font-weight: bold;
    `}
`;

const ItemList = styled.li`
    padding: 0 15px 0 0;
    list-style: none;

    ${media.md`
        padding: 0 40px 0 0;
    `};

    ${media.xl`
        padding: 0 75px 0 0;
    `};
`;

const ItemGroup = styled.ul<any>`
    margin: 0;
    padding: 0;
    display: inline-flex;
    position: relative;

    &:after {
        height: 4px;
        background-color: ${props => props.theme.primaryColor};
        content: '';
        display: block;
        width: ${props => (props.bottomLineWidth ? `${props.bottomLineWidth}px` : 0)};
        position: absolute;
        left: 0;
        bottom: 0;
        transform: translateX(${props => (props.itemPosition ? `${props.itemPosition}px` : 0)});
        transition: transform .1s ease;
    }
`;

const TabScrollRoot = styled.section<any>`
    color: #fff;
    position: relative;
    overflow: auto;
    scroll-direction: horizontal;

    /* width */
    ::-webkit-scrollbar {
        display: none;
        height: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background-color: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.primaryColor};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background-color: ${props => props.theme.primaryColor};
    }

    ${media.lg`
        ::-webkit-scrollbar {
            display: block;
        }
    `};
`;
